import { openBlock as e, createElementBlock as t, createStaticVNode as a } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, c = /* @__PURE__ */ a('<g clip-path="url(#a)"><path fill-rule="evenodd" d="M8.2.641a1.083 1.083 0 0 0-.399 0c-.157.03-.297.101-.358.132l-.016.009L.999 3.996a.75.75 0 0 0 0 1.341l1.873.937L.966 7.346A.75.75 0 0 0 1 8.671l6.428 3.214.016.008c.06.031.2.103.358.132.132.025.268.025.4 0 .157-.03.297-.1.358-.132l.016-.008 6.428-3.214a.75.75 0 0 0 .032-1.325L13.13 6.274l1.874-.937a.75.75 0 0 0 0-1.341L8.575.782 8.559.773C8.498.743 8.358.671 8.2.641ZM3.012 4.667l4.99-2.495 4.99 2.495L8 7.16 3.01 4.667Z" clip-rule="evenodd"></path><path d="M1.67 10.662a.75.75 0 0 0-.671 1.342l6.428 3.214.016.008c.06.031.2.103.358.133.132.024.268.024.4 0 .157-.03.297-.101.358-.133l.016-.008 6.428-3.214a.75.75 0 1 0-.67-1.342L8 13.828l-6.33-3.166Z"></path></g><defs><clipPath id="a"><path d="M0 0h16v16H0z"></path></clipPath></defs>', 2), o = [
  c
];
function d(p, r) {
  return e(), t("svg", l, [...o]);
}
const n = { render: d };
export {
  n as default,
  d as render
};
